import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { changePassword } from "../../store/actions";
import { Link, useNavigate } from "react-router-dom";
import ResetPassword from "./resetPassword";
import OtpScreen from "./otpScreen";
import EmailScreen from "./emailScreen";

const ChangePasswordForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fieldTab, setFieldTab] = useState("email");
  const [state, setState] = useState({ email: "" });
  const handleChange = (e) => {};

  const handleSubmit = (e) => {
    e.preventDefault();
    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("");
        setTimeout(() => {
          // navigate("/");
        }, 500);
      } else {
        toast.error("");
      }
    };
    dispatch(changePassword(state, callBack));
  };

  return (
    <>
      <section className="profile-main py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Change Password</h4>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  {fieldTab == "email" && (
                    <EmailScreen
                      state={state}
                      setState={setState}
                      setFieldTab={setFieldTab}
                    />
                  )}
                  {fieldTab == "otp" && (
                    <OtpScreen
                      state={state}
                      setState={setState}
                      setFieldTab={setFieldTab}
                    />
                  )}
                  {fieldTab == "reset" && (
                    <ResetPassword
                      state={state}
                      setState={setState}
                      setFieldTab={setFieldTab}
                    />
                  )}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ChangePasswordForm;
